module.exports = __webpack_public_path__ + "static/img/4020_phase_function_Paper_Points.cf575e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4020_phase_function_Paper_Points.png
// module id = PCVw
// module chunks = 0